export default __webpack_public_path__ + "95fd1c3370ad986c9a3012574e5e0bc7.png";